// prototype.js の古い特定のバージョンが Array.prototype.toJSON 関数を勝手に生やしている結果、
// JSON.stringify(this.toJSON) を実行した際に、本来は Array な プロパティが String になってしまうことがある。
// またprototype.js以外にもJSONを壊すような3rd party scriptが今後読まれうることもあるため
// どのような形でもJSONが壊れたことを検知できるようにする。
// ref. https://edwardkenfox.com/blog/broken-json.stringify-and-prototype.js/
export const isMalformedJson = (json: object) => {
  return typeof json !== typeof JSON.parse(JSON.stringify(json));
};
